export enum PaymentState {
  Unknown = 0,
  Paid = 1,
  Pending = 2,
  Failed = 3,
  Refunded = 4,
  Disputed = 5,
}
